// extracted by mini-css-extract-plugin
module.exports = {"input-text":"input-text--cfae7f","inputText":"input-text--cfae7f"};